<template>
  <div class="request-folio-view">
    <h5 class="request-folio-view__title">
      <i class="fas fa-check" /> Validación de Folios
    </h5>
    <div class="row justify-content-center">
      <div class="col-12 col-md-10 col-lg-6">
        <div v-if="successUpdatedFolio" class="alert alert-success">
          <div class="request-folio-form__dialog-body text-center">
            <div>
              <i class="fas fa-check-circle" />
            </div>
            <h4>La dispensación de la prescripción con folio <strong>{{ successUpdatedFolio }}</strong> se ha realizado satisfactoriamente</h4>
          </div>
        </div>
        <div v-else class="card">
          <div class="card-header">
            <app-media-object>
              <template v-slot:icon>
                <i class="fas fa-sticky-note" />
              </template>
              <template v-slot:info>
                Ingresar Folio
              </template>
              <div>
                Receta gráfica
              </div>
            </app-media-object>
            <el-radio-group v-model="selectedLabel">
              <el-radio-button v-for="(label, type) in types" :key="type" :label="label" />
            </el-radio-group>
          </div>
          <div class="card-body">
            <request-folio-form :is-medical-center="isMedicalCenter" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import _invert from 'lodash/invert';
import RequestFolioForm from '@/components/folio/RequestFolioForm';
import AppMediaObject from '@/components/AppMediaObject';

const TYPES = {
  'medic': 'Prescriptor Particular',
  'medical-center': 'Centro de Salud'
};

export default {
  name: 'RequestFolioView',
  components: {
    AppMediaObject,
    RequestFolioForm
  },
  data() {
    return {
      types: TYPES,
      selectedLabel: 'Prescriptor Particular'
    };
  },
  computed: {
    isMedicalCenter() {
      return this.selectedType === 'medical-center';
    },
    selectedType() {
      return _invert(this.types)[this.selectedLabel];
    },
    successUpdatedFolio() {
      return this.$route.params.folio;
    }
  },
  methods: {
    success(folio) {
      this.$router.push(`/request-folio/${folio}/success`);
    }
  }
};
</script>

<style lang="scss">
.request-folio-view {
  &__title {
    color: $--color-white;
    margin: $--spacing-6 0;
  }

  .card-header {
    background-color: $--color-white;
    display: flex;
    justify-content: space-between;
  }
}
</style>
